import { ChakraProps } from "@chakra-ui/system"

/** This method return the styles for increasing clickable area around the element */
export const addHitAreaStyle = ({ top = 5, left = 5, right= 5, bottom = 5 } = {}) => {
  return {
    // position: "relative",
    // display: "inline-block",
    _before: {
      content: '""',
      position: "absolute",
      top: `-${top}px`,
      left: `-${left}px`,
      right: `-${right}px`,
      bottom: `-${bottom}px`,
    }
  }
}